import { type Actions, ActionType } from './categories.actions';
import { categoryAdapter, initialState, type State } from './categories.state';

export function categoriesReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return initialState;
        }
        case ActionType.FETCH_CATEGORIES: {
            return {
                ...state,
                isPending: true
            };
        }
        case ActionType.FETCH_CATEGORIES_SUCCEEDED: {
            return categoryAdapter.setAll(action.payload.categories, { ...state, isLoaded: true, isPending: false });
        }
        case ActionType.FETCH_CATEGORIES_FAILED: {
            return { ...state, isLoaded: false, isPending: false };
        }
        case ActionType.CREATE_CATEGORY: {
            return categoryAdapter.addOne(action.payload.category, { ...state, isLoaded: true, isPending: false });
        }
        case ActionType.UPDATE_CATEGORY: {
            return categoryAdapter.updateOne(
                {
                    id: action.payload.categoryId,
                    changes: action.payload.categoryUpdate
                },
                state
            );
        }
        case ActionType.REMOVE_CATEGORY: {
            return categoryAdapter.removeOne(action.payload.categoryId, state);
        }
        case ActionType.UPDATE_RANK: {
            return categoryAdapter.updateMany(
                action.payload.map(newRanks => {
                    return { id: newRanks.categoryId, changes: newRanks.rank };
                }),
                state
            );
        }
        default:
            return state;
    }
}
